export default [
    {
        path: 'my-reminders',
        name: 'my-reminders',
        meta: {
            modules: ['crm'],
            authentication_required: true,
            authorization_required: null,
            translate: (t) => {
                return t('menu_points.my_reminders').ucFirst();
            },
        },
        component: () => import('@/views/helpers/grouper/grouper.vue'),
        redirect: { name: 'my-reminders-list' },
        children: [
            {
                path: '',
                name: 'my-reminders-list',
                meta: {
                    modules: ['crm'],
                    authentication_required: true,
                    authorization_required: null,
                    translate: (t) => {
                        return t('menu_points.my_reminders').ucFirst();
                    },
                },
                component: () => import('@/views/pages/reminders/own.vue'),
                props: { own: true },
            },
            {
                path: 'create',
                name: 'my-reminder-create',
                meta: {
                    modules: ['crm'],
                    authentication_required: true,
                    authorization_required: null,
                    translate: (t, tc) => t('base.create_new_item', {item: tc('reminders::reminders.reminder', 1)}).ucFirst()
                },
                component: () => import('@/views/pages/reminders/item.vue'),
                props: { own: true },
            },
            {
                path: ':id(\\d+)',
                name: 'my-reminder-edit',
                meta: {
                    modules: ['crm'],
                    authentication_required: true,
                    authorization_required: null,
                    translate: (t, tc) => t('base.edit_item', {item: tc('reminders::reminders.reminder', 1)}).ucFirst()
                },
                component: () => import('@/views/pages/reminders/item.vue'),
                props: { own: true },
            },
        ]
    },
];